import { render, staticRenderFns } from "./WincareOldAdminEventiList.vue?vue&type=template&id=29cd9e60"
import script from "./WincareOldAdminEventiList.vue?vue&type=script&lang=js"
export * from "./WincareOldAdminEventiList.vue?vue&type=script&lang=js"
import style0 from "./WincareOldAdminEventiList.vue?vue&type=style&index=0&id=29cd9e60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports